/* eslint react/forbid-prop-types: 0 */
/* eslint react/no-multi-comp: 0 */
/* eslint react/prefer-stateless-function: 0 */
/* eslint react/require-default-props: 0 */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { Button, Glyphicon } from "react-bootstrap";
import DatePicker from "react-datepicker";

class CalendarWithDate extends Component {
  render() {
    return (
      <Button className="align-top" onClick={this.props.onClick}>
        <Glyphicon glyph="calendar" /> {this.props.value}
      </Button>
    );
  }
}
CalendarWithDate.propTypes = {
  onClick: PropTypes.func,
  value: PropTypes.string
};

class TableDatePicker extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(date) {
    this.props.onChange(date);
  }

  render() {
    return (
      <DatePicker
        className="tbp"
        dateFormat="DD/MM/YYYY"
        todayButton={"Today"}
        customInput={<CalendarWithDate />}
        selected={this.props.date}
        onChange={this.handleChange}
      />
    );
  }
}
TableDatePicker.propTypes = {
  onChange: PropTypes.func.isRequired
}

export default TableDatePicker;



// WEBPACK FOOTER //
// ./src/components/runsheets/list/TableDatePicker.js